import { InputCard } from '@ui/components/Input/InputCard';
import { InputChips } from '@ui/components/Input/InputChips';
import {
  validateMaxDecimals,
  validateMaxValue,
  validateMinValue,
  validateNotEmpty,
  validateNotZero,
  validateNumberFormat,
} from '@ui/utils/validations';
import { useTranslations } from 'next-intl';
import React, { useMemo } from 'react';

import { useH2SwapSlippageDialog } from './useH2SwapSlippageDialog';

export const H2SlippageInput = () => {
  const enteredStr = useH2SwapSlippageDialog((s) => s.enteredStr);
  const setSlippage = useH2SwapSlippageDialog((s) => s.setEnteredStr);
  const t = useTranslations();

  const inputError = useMemo(() => {
    return (
      validateNotEmpty({
        t,
        value: enteredStr,
      }) ??
      validateNumberFormat({
        t,
        value: enteredStr,
      }) ??
      validateNotZero({
        t,
        value: enteredStr,
      }) ??
      validateMinValue({
        t,
        value: enteredStr,
        minValue: 0,
      }) ??
      validateMaxValue({
        t,
        value: enteredStr,
        maxValue: 2,
        errorMessage: t('common.must be at most {max}', { max: 2 }),
      }) ??
      validateMaxDecimals({
        t,
        value: enteredStr,
        maxDecimals: 2,
      })
    );
  }, [t, enteredStr]);

  return (
    <InputCard
      flex="1"
      value={enteredStr}
      error={inputError}
      label="Slippage tolerance"
      unit="%"
      inputChips={
        <InputChips
          value={enteredStr}
          maxValue={2}
          decimalPlaces={2}
          onChange={setSlippage}
          renderValue={(value) => `${value}%`}
        />
      }
      onChange={(e) => setSlippage(e.target.value)}
    />
  );
};
